import { makeAutoObservable } from 'mobx';

import AuthorizationService from '../http/auth-service';
import { isAdmin, isRoot, IUser } from '../types/user';

export class User {
    private data: IUser;
    constructor(data: IUser) {
        this.data = data;
    }

    get login(): string {
        return this.data.login;
    }

    get user_id(): number {
        return this.data.user_id;
    }

    get node_id(): number {
        return this.data.node_id;
    }

    isAdmin(): boolean {
        return isAdmin(this.data);
    }
    isRoot(): boolean {
        return isRoot(this.data);
    }
}

//=================================================================================================
export class AuthStore {
    private _user: User | null = null;
    private _loading: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    get user(): User | null {
        return this._user;
    }

    get loading(): boolean {
        return this._loading;
    }

    async login(login: string, password: string) {
        try {
            this._loading = true;
            const response = await AuthorizationService.login(login, password);
            localStorage.setItem('token', response.data.aT);
            this._user = new User(response.data.user);
        } catch (e) {
            this._user = null;
            throw e;
        } finally {
            this._loading = false;
        }
    }

    async logout() {
        try {
            this._loading = true;
            await AuthorizationService.logout();
            localStorage.removeItem('token');
            this._user = null;
        } catch (e) {
            throw e;
        } finally {
            this._loading = false;
        }
    }

    async refresh() {
        try {
            this._loading = true;
            const response = await AuthorizationService.refresh();
            localStorage.setItem('token', response.data.aT);
            this._user = new User(response.data.user);
        } catch (e) {
            throw e;
        } finally {
            this._loading = false;
        }
    }
}
